import {
    AUTH_SESSION_PATH,
    AUTH_LOGOUT_PATH,
    HYBRIS_LOGOUT_PATH,
    HYBRIS_SESSION_PATH,
} from '@/constants/routes.constants';
import { type MieleStoredGlobals } from '@/types/shared-types';
import { handleMultilingualPrefix } from '@/utils/domainUtils';

export interface Instance {
    checkAuthSessionValid: () => Promise<boolean>;
    logoutAuthSession: () => Promise<boolean>;
    checkHybrisSessionValid: () => Promise<boolean>;
    logoutHybrisSession: () => Promise<boolean>;
}

export type MieleAuthServiceInterface = { (arg: MieleStoredGlobals): Instance } & {
    new (arg: MieleStoredGlobals): Instance;
};

function MieleAuthService(globalsConfig: MieleStoredGlobals) {
    const API_CONNECTOR_HOST = globalsConfig['general.experienceApi'];
    const HYBRIS_HOST_NAME = import.meta.env.DEV ? import.meta.env.VITE_HYBRIS_HOST : window.location.origin;

    const checkAuthSessionValid = async () => {
        const response = await fetch(`${API_CONNECTOR_HOST}${AUTH_SESSION_PATH}`, { credentials: 'include' });
        const data = await response.json();
        return data?.auth?.authenticated || false;
    };

    const logoutAuthSession = async () => {
        const response = await fetch(`${API_CONNECTOR_HOST}${AUTH_LOGOUT_PATH}`, { credentials: 'include' });
        return response.ok;
    };

    const logoutHybrisSession = async () => {
        const response = await fetch(`${HYBRIS_HOST_NAME}${handleMultilingualPrefix(HYBRIS_LOGOUT_PATH)}`);
        return response.ok;
    };

    const checkHybrisSessionValid = async () => {
        try {
            const response = await fetch(`${HYBRIS_HOST_NAME}${handleMultilingualPrefix(HYBRIS_SESSION_PATH)}`);
            return response.ok;
        } catch (e) {
            const err = e ?? new Error('Unexpected Error');
            console.error('error:checkHybrisSessionValid', err);
            throw err;
        }
    };

    return {
        checkAuthSessionValid,
        logoutAuthSession,
        checkHybrisSessionValid,
        logoutHybrisSession,
    };
}

export default MieleAuthService as MieleAuthServiceInterface;
